/* Pacific Urban Finishes - Reviews widget engine (Loox replacement) */
(function () {
  'use strict';

  var DATA = window.PUF_REVIEWS_DATA || { meta: {}, reviews: [] };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var STAR_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="' +
    'M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289a.85.85 0 ' +
    '0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-.174L12 19.869l-6.476 3.404c-.212.115' +
    '-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24' +
    '-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183' +
    '-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z"/></svg>';
  var FIVE_STARS = STAR_SVG + STAR_SVG + STAR_SVG + STAR_SVG + STAR_SVG;

  function starsHTML(rating) {
    var pct = (Math.max(0, Math.min(5, rating)) / 5) * 100;
    return '<span class="puf-stars" role="img" aria-label="' + rating + ' out of 5 stars">' +
      '<span class="puf-stars__bg">' + FIVE_STARS + '</span>' +
      '<span class="puf-stars__fill" style="width:' + pct + '%">' + FIVE_STARS + '</span></span>';
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
  var IMG_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1 2v7.6l4-4 ' +
    '3 3 4-4 3 3V7H5zm3 1.2a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2z"/></svg>';
  var FILTER_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round"><path d="M3 6h18M6 12h12M10 18h4"/></svg>';

  var VERIFIED = '<span class="puf-verified"><span class="puf-verified__check">' + CHECK_SVG +
    '</span>Verified</span>';

  /* ---------- photo lightbox ---------- */
  function openLightbox(photos, start) {
    var idx = start || 0;
    var box = document.createElement('div');
    box.className = 'puf-lightbox';
    box.innerHTML =
      '<button class="puf-lightbox__close" aria-label="Close">&times;</button>' +
      '<button class="puf-lightbox__nav puf-lightbox__nav--prev" aria-label="Previous">&#8249;</button>' +
      '<button class="puf-lightbox__nav puf-lightbox__nav--next" aria-label="Next">&#8250;</button>' +
      '<img alt="Review photo">';
    var img = box.querySelector('img');
    function show() { img.src = photos[idx]; }
    function close() { box.remove(); document.removeEventListener('keydown', onKey); }
    function nav(d) { idx = (idx + d + photos.length) % photos.length; show(); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') nav(-1);
      else if (e.key === 'ArrowRight') nav(1);
    }
    box.querySelector('.puf-lightbox__close').onclick = close;
    box.querySelector('.puf-lightbox__nav--prev').onclick = function (e) { e.stopPropagation(); nav(-1); };
    box.querySelector('.puf-lightbox__nav--next').onclick = function (e) { e.stopPropagation(); nav(1); };
    box.onclick = function (e) { if (e.target === box) close(); };
    if (photos.length < 2) {
      box.querySelector('.puf-lightbox__nav--prev').style.display = 'none';
      box.querySelector('.puf-lightbox__nav--next').style.display = 'none';
    }
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
    show();
  }

  /* ---------- review card ---------- */
  function cardHTML(r) {
    var photo = '';
    if (r.photos && r.photos.length) {
      var extra = r.photos.length - 1;
      var badge = extra > 0
        ? '<span class="puf-card__photo-badge">' + IMG_SVG + '+' + extra + '</span>'
        : '';
      photo = '<div class="puf-card__photo-wrap">' +
        '<img class="puf-card__photo" loading="lazy" src="' + esc(r.photos[0]) +
        '" alt="Photo from ' + esc(r.name) + '’s review">' + badge + '</div>';
    }
    var body = r.body || '';
    var truncated = body.length > 280;
    var shown = truncated ? body.slice(0, 280).replace(/\s+\S*$/, '') + '… ' : body;
    var more = truncated ? '<span class="puf-more">Read more</span>' : '';
    return '<article class="puf-card" data-puf-id="' + esc(r.id) + '">' + photo +
      '<div class="puf-card__body">' +
      '<div class="puf-card__name">' + esc(r.name) + (r.verified ? VERIFIED : '') + '</div>' +
      starsHTML(r.rating) +
      '<div class="puf-card__text">' + esc(shown) + more + '</div>' +
      '</div></article>';
  }

  /* ---------- review modal (full review, photo carousel) ---------- */
  function openReviewModal(r) {
    var photos = (r.photos || []).slice();
    var idx = 0;
    var hasPhotos = photos.length > 0;
    var reply = r.reply
      ? '<div class="puf-card__reply"><strong>Pacific Urban Finishes replied:</strong>' +
        esc(r.reply) + '</div>'
      : '';
    var navHTML = photos.length > 1
      ? '<button class="puf-rm-nav puf-rm-nav--prev" aria-label="Previous photo">&#8249;</button>' +
        '<button class="puf-rm-nav puf-rm-nav--next" aria-label="Next photo">&#8250;</button>' +
        '<div class="puf-rm-dots">' +
        photos.map(function (_, i) {
          return '<span class="puf-rm-dot' + (i === 0 ? ' on' : '') + '"></span>';
        }).join('') + '</div>'
      : '';
    var media = '<div class="puf-review-modal__media' +
      (hasPhotos ? '' : ' puf-review-modal__media--empty') + '">' +
      (hasPhotos ? '<img class="puf-rm-photo" alt="Review photo">' + navHTML : '') +
      '</div>';
    var m = document.createElement('div');
    m.className = 'puf-modal';
    m.innerHTML =
      '<div class="puf-modal__box">' +
      '<button class="puf-modal__close" aria-label="Close">&times;</button>' +
      '<div class="puf-review-modal">' + media +
      '<div class="puf-review-modal__content">' +
      '<div class="puf-card__name">' + esc(r.name) + (r.verified ? VERIFIED : '') + '</div>' +
      starsHTML(r.rating) +
      '<div class="puf-card__text">' + esc(r.body || '') + '</div>' + reply +
      '</div></div></div>';

    function close() { m.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (hasPhotos && photos.length > 1 && e.key === 'ArrowLeft') nav(-1);
      else if (hasPhotos && photos.length > 1 && e.key === 'ArrowRight') nav(1);
    }
    m.onclick = function (e) { if (e.target === m) close(); };
    m.querySelector('.puf-modal__close').onclick = close;

    if (hasPhotos) {
      var img = m.querySelector('.puf-rm-photo');
      var dots = m.querySelectorAll('.puf-rm-dot');
      function show() {
        img.src = photos[idx];
        dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      }
      function nav(d) { idx = (idx + d + photos.length) % photos.length; show(); }
      if (photos.length > 1) {
        m.querySelector('.puf-rm-nav--prev').onclick = function (e) { e.stopPropagation(); nav(-1); };
        m.querySelector('.puf-rm-nav--next').onclick = function (e) { e.stopPropagation(); nav(1); };
      }
      img.addEventListener('click', function () { openLightbox(photos, idx); });
      show();
    }
    document.addEventListener('keydown', onKey);
    document.body.appendChild(m);
  }

  /* ---------- write a review modal ---------- */
  function openWriteModal(handle) {
    var rating = 0;
    var titleEl = document.querySelector('.product-title') || document.querySelector('h1');
    var productTitle = titleEl ? titleEl.textContent.trim() : handle;
    var m = document.createElement('div');
    m.className = 'puf-modal';
    m.innerHTML =
      '<div class="puf-modal__box puf-modal__box--form">' +
      '<button class="puf-modal__close" aria-label="Close">&times;</button>' +
      '<div class="puf-form-box">' +
      '<h3>Write a review</h3>' +
      '<p class="puf-form-sub">' + esc(productTitle) + '</p>' +
      '<form data-puf-form novalidate>' +
      '<div class="puf-field"><label>Score</label>' +
      '<div class="puf-form-stars" data-puf-rate>' +
      [1, 2, 3, 4, 5].map(function (i) {
        return '<button type="button" data-v="' + i + '" aria-label="' + i + ' stars">' + STAR_SVG + '</button>';
      }).join('') +
      '</div></div>' +
      '<div class="puf-field"><label>Your review</label>' +
      '<textarea name="body" required placeholder="Tell us what you think about this product..."></textarea></div>' +
      '<div class="puf-field"><label>Your name</label><input name="name" required></div>' +
      '<div class="puf-field"><label>Your email</label><input type="email" name="email" required></div>' +
      '<p class="puf-form-note">Your review will be checked before it appears on the site. ' +
      'Have photos? Reply to the confirmation email with them attached.</p>' +
      '<div class="puf-form-actions">' +
      '<button type="button" class="puf-btn puf-btn--outline" data-puf-cancel>Cancel</button>' +
      '<button type="submit" class="puf-btn">Submit review</button>' +
      '</div></form></div></div>';

    var starBtns = m.querySelectorAll('[data-puf-rate] button');
    function paint(n) {
      starBtns.forEach(function (b, i) { b.classList.toggle('on', i < n); });
    }
    starBtns.forEach(function (b, i) {
      b.addEventListener('mouseenter', function () { paint(i + 1); });
      b.addEventListener('click', function () { rating = i + 1; paint(rating); });
    });
    m.querySelector('[data-puf-rate]').addEventListener('mouseleave', function () { paint(rating); });

    function close() { m.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.onclick = function (e) { if (e.target === m) close(); };
    m.querySelector('.puf-modal__close').onclick = close;
    m.querySelector('[data-puf-cancel]').onclick = close;
    document.addEventListener('keydown', onKey);

    m.querySelector('[data-puf-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.target;
      if (!rating) { alert('Please select a star rating.'); return; }
      if (!f.body.value.trim() || !f.name.value.trim() || !f.email.value.trim()) {
        alert('Please fill in your review, name and email.');
        return;
      }
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[Subject]', 'Review approval needed: ' + productTitle);
      fd.append('contact[name]', f.name.value);
      fd.append('contact[email]', f.email.value);
      fd.append('contact[body]',
        'NEW REVIEW — PENDING YOUR APPROVAL\n\n' +
        'Product: ' + productTitle + ' (handle: ' + handle + ')\n' +
        'Rating: ' + rating + ' / 5\n' +
        'Reviewer: ' + f.name.value + ' <' + f.email.value + '>\n\n' +
        'Review:\n' + f.body.value + '\n\n' +
        '------\nThis review will NOT appear on the website until you approve and add it.');
      var btn = f.querySelector('[type="submit"]');
      btn.disabled = true; btn.textContent = 'Submitting…';
      fetch('/contact', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok && r.status !== 0) throw new Error('bad status');
          m.querySelector('.puf-form-box').innerHTML =
            '<h3>Thank you!</h3>' +
            '<p class="puf-form-sub">Your review has been submitted and will appear ' +
            'on the site once it is approved.</p>' +
            '<div class="puf-form-actions"><button class="puf-btn" data-puf-done>Close</button></div>';
          m.querySelector('[data-puf-done]').onclick = close;
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'Submit review';
          alert('Something went wrong submitting your review. Please try again.');
        });
    });
    document.body.appendChild(m);
  }

  /* ---------- shared list widget (product + aggregate) ---------- */
  function renderListWidget(el, all, opts) {
    var byId = {};
    all.forEach(function (r) { byId[r.id] = r; });
    var total = all.length;
    var avg = total ? all.reduce(function (s, r) { return s + r.rating; }, 0) / total : 0;
    if (opts.aggregate && DATA.meta) {
      total = DATA.meta.total || total;
      avg = DATA.meta.average ? Number(DATA.meta.average) : avg;
    }
    var dist = [0, 0, 0, 0, 0];
    all.forEach(function (r) { dist[r.rating - 1]++; });

    var bars = '';
    for (var s = 5; s >= 1; s--) {
      var n = dist[s - 1];
      var pct = all.length ? (n / all.length * 100) : 0;
      bars += '<div class="puf-bar">' + starsHTML(s) +
        '<span class="puf-bar__track"><span class="puf-bar__fill" style="width:' + pct + '%"></span></span>' +
        '<span class="puf-bar__count">(' + n + ')</span></div>';
    }

    var writeBtn = opts.showWrite
      ? '<button class="puf-btn puf-btn--outline" data-puf-write>Write a review</button>' : '';

    el.innerHTML =
      (opts.heading ? '<h2>' + esc(opts.heading) + '</h2>' : '') +
      '<div class="puf-rv__header">' +
      '<div class="puf-rv__summary">' +
      '<span class="puf-rv__bigstar">★</span>' +
      '<span class="puf-rv__summary-text">' +
      '<span class="puf-rv__avg">' + avg.toFixed(1) + '<small>/5</small></span>' +
      starsHTML(avg) +
      '<span class="puf-rv__count">' + total + ' Review' + (total !== 1 ? 's' : '') + '</span>' +
      '</span></div>' +
      '<div class="puf-rv__bars">' + bars + '</div>' +
      '<div class="puf-rv__actions">' + writeBtn +
      '<div class="puf-rv__filter">' +
      '<button class="puf-rv__filter-btn" data-puf-filter-btn aria-label="Filter reviews">' + FILTER_SVG + '</button>' +
      '</div></div></div>' +
      '<div class="puf-rv__grid" data-puf-grid></div>' +
      '<div class="puf-rv__more"><button class="puf-btn puf-btn--outline" data-puf-more>Show more reviews</button></div>';

    var grid = el.querySelector('[data-puf-grid]');
    var moreWrap = el.querySelector('.puf-rv__more');
    var perPage = opts.initial;
    var shown = 0;
    var mode = 'recent';
    var columns = [];
    var curCols = 0;
    var placed = [];   // card DOM elements in data order

    function colCount() {
      var w = grid.offsetWidth || el.offsetWidth || 1200;
      if (w > 1000) return 4;
      if (w > 700) return 3;
      return 2;
    }
    function buildColumns() {
      curCols = colCount();
      grid.innerHTML = '';
      columns = [];
      for (var i = 0; i < curCols; i++) {
        var c = document.createElement('div');
        c.className = 'puf-rv__col';
        grid.appendChild(c);
        columns.push(c);
      }
    }
    function shortestCol() {
      var m = columns[0];
      for (var i = 1; i < columns.length; i++) {
        if (columns[i].offsetHeight < m.offsetHeight) m = columns[i];
      }
      return m;
    }
    function makeCard(r) {
      var tmp = document.createElement('div');
      tmp.innerHTML = cardHTML(r);
      var c = tmp.firstElementChild;
      c.addEventListener('click', function () {
        var rev = byId[c.dataset.pufId];
        if (rev) openReviewModal(rev);
      });
      return c;
    }
    function relayout() {
      buildColumns();
      placed.forEach(function (card) { shortestCol().appendChild(card); });
    }

    function current() {
      var list = all.slice();
      if (mode === 'photos') list = list.filter(function (r) { return r.photos && r.photos.length; });
      else if (mode === 'highest') list.sort(function (a, b) { return b.rating - a.rating; });
      else if (mode === 'lowest') list.sort(function (a, b) { return a.rating - b.rating; });
      return list;
    }
    function draw(reset) {
      var list = current();
      if (reset) { placed = []; shown = 0; buildColumns(); }
      list.slice(shown, shown + perPage).forEach(function (r) {
        var card = makeCard(r);
        placed.push(card);
        shortestCol().appendChild(card);
      });
      shown = Math.min(shown + perPage, list.length);
      moreWrap.style.display = shown >= list.length ? 'none' : '';
    }

    if (opts.showWrite) {
      el.querySelector('[data-puf-write]').onclick = function () { openWriteModal(opts.handle); };
    }
    el.querySelector('[data-puf-more]').onclick = function () { draw(false); };

    var filterWrap = el.querySelector('.puf-rv__filter');
    var menu = null;
    var OPTIONS = [
      ['recent', 'Most recent'],
      ['highest', 'Highest rating'],
      ['lowest', 'Lowest rating'],
      ['photos', 'With photos']
    ];
    el.querySelector('[data-puf-filter-btn]').addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu) { menu.remove(); menu = null; return; }
      menu = document.createElement('div');
      menu.className = 'puf-filter-menu';
      menu.innerHTML = OPTIONS.map(function (o) {
        return '<button data-v="' + o[0] + '" aria-selected="' + (o[0] === mode) + '">' + o[1] + '</button>';
      }).join('');
      menu.querySelectorAll('button').forEach(function (b) {
        b.onclick = function () { mode = b.dataset.v; menu.remove(); menu = null; draw(true); };
      });
      filterWrap.appendChild(menu);
    });
    document.addEventListener('click', function (e) {
      if (menu && !filterWrap.contains(e.target)) { menu.remove(); menu = null; }
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (colCount() !== curCols) relayout(); }, 200);
    });

    draw(true);
  }

  /* ---------- product widget ---------- */
  function renderProduct(el) {
    var handle = el.dataset.pufHandle || '';
    var heading = el.dataset.pufHeading || 'Customer Reviews';
    var all = DATA.reviews.filter(function (r) { return r.handle === handle; });
    if (!all.length) {
      el.innerHTML = '<h2>' + esc(heading) + '</h2>' +
        '<div class="puf-rv__empty">No reviews yet. Be the first to review this product!</div>' +
        '<div style="text-align:center"><button class="puf-btn" data-puf-write>Write a review</button></div>';
      el.querySelector('[data-puf-write]').onclick = function () { openWriteModal(handle); };
      return;
    }
    renderListWidget(el, all, {
      heading: heading, showWrite: true, handle: handle, initial: 4, aggregate: false
    });
  }

  /* ---------- aggregate widget (homepage) ---------- */
  function renderAggregate(el) {
    var all = DATA.reviews.slice();
    if (!all.length) { el.innerHTML = ''; return; }
    renderListWidget(el, all, {
      heading: '', showWrite: false, handle: '', initial: 4, aggregate: true
    });
  }

  /* ---------- trust badge ---------- */
  function renderBadge(el) {
    var meta = DATA.meta || {};
    var avg = meta.average ? Number(meta.average).toFixed(1) : '5.0';
    var total = meta.total || (DATA.reviews ? DATA.reviews.length : 0);
    el.innerHTML =
      starsHTML(meta.average || 5) +
      '<span class="puf-badge__avg">' + avg + '/5</span>' +
      '<span class="puf-badge__sep">|</span>' +
      '<span class="puf-badge__count"><strong>' + total + '</strong> Reviews</span>';
  }

  /* ---------- inline rating under product title ---------- */
  function injectInlineRating() {
    var widget = document.querySelector('.puf-rv[data-puf-mode="product"]');
    if (!widget) return;
    var info = document.querySelector('.product-info');
    if (!info || info.querySelector('.puf-inline-rating')) return;
    var handle = widget.dataset.pufHandle || '';
    var list = DATA.reviews.filter(function (r) { return r.handle === handle; });
    if (!list.length) return;
    var avg = list.reduce(function (s, r) { return s + r.rating; }, 0) / list.length;
    var div = document.createElement('div');
    div.className = 'product-info__block product-info__block--sm puf-inline-rating';
    div.innerHTML = '<a class="puf-inline-rating__link" role="button" tabindex="0">' +
      starsHTML(avg) +
      '<span class="puf-inline-rating__text">' + avg.toFixed(1) +
      ' - (' + list.length + ') Verified Reviews</span></a>';
    div.querySelector('a').addEventListener('click', function () {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    info.insertBefore(div, info.firstChild);
  }

  /* ---------- floating "Reviews" tab ---------- */
  function injectFloatingTab() {
    if (document.querySelector('.puf-fab')) return;
    var widget = document.querySelector('.puf-rv[data-puf-mode="product"], .puf-rv[data-puf-mode="aggregate"]');
    if (!widget) return;
    var btn = document.createElement('button');
    btn.className = 'puf-fab';
    btn.setAttribute('aria-label', 'Jump to reviews');
    btn.innerHTML = '<span class="puf-fab__txt">Reviews</span>';
    btn.addEventListener('click', function () {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    document.body.appendChild(btn);
  }

  /* ---------- init ---------- */
  function applyVars(el) {
    if (el.dataset.pufAccent) el.style.setProperty('--puf-accent', el.dataset.pufAccent);
  }

  function init() {
    document.querySelectorAll('.puf-rv').forEach(function (el) {
      if (el.dataset.pufReady) return;
      el.dataset.pufReady = '1';
      applyVars(el);
      var mode = el.dataset.pufMode;
      if (mode === 'product') renderProduct(el);
      else if (mode === 'aggregate') renderAggregate(el);
      else if (mode === 'badge') renderBadge(el);
    });
    injectInlineRating();
    injectFloatingTab();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
